module.exports = __webpack_public_path__ + "img/texture-brick-2-side.e2a595b3.jpg";